const { PLANS, didUserSubscribeBeforePlansChanges } = require('./customerStatus.cjs');

module.exports = (userData) => {
  const customerStatusData = PLANS[userData.customerStatus];
  const draftsLimit = customerStatusData.limits.drafts;
  if (didUserSubscribeBeforePlansChanges(userData) || draftsLimit === Infinity) return false;
  return userData.draftPostCount >= draftsLimit;
};
